export function setHtml(element: HTMLElement|null, html: string) {
    if (element) {
        element.innerHTML = html;
    }
}